import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, allocatedExpensesBudget }) =>
    present(
      repository
        .updateProjectAllocatedExpensesBudget(project, allocatedExpensesBudget)
        .then(() => ({ project, allocatedExpensesBudget }))
        .catch(() => Promise.reject({ project, allocatedExpensesBudget })),
    );
}

export type { Interactor };

export { createInteractor };
